import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HeroBlockComponent } from './hero-block/hero-block.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ProgramCardComponent } from './programs/ui/program-card.component';
import { CodecraftQuizReviewComponent } from './quiz/features/quiz-review.component';
import { CodecraftQuizComponent } from './quiz/features/quiz.component';
import { TicTacToeComponent } from './tic-tac-toe/tic-tac-toe.component';
import { WebProjectFooterComponent } from './web-project-footer/web-project-footer.component';

@NgModule({
  imports: [
    CommonModule,
    HeroBlockComponent,
    CodecraftQuizComponent,
    LoadingSpinnerComponent,
    TicTacToeComponent,
    WebProjectFooterComponent,
    ProgramCardComponent,
    CodecraftQuizReviewComponent
  ],
  exports: [
    HeroBlockComponent,
    TicTacToeComponent,
    CodecraftQuizComponent,
    LoadingSpinnerComponent,
    WebProjectFooterComponent,
    ProgramCardComponent,
    CodecraftQuizReviewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule { }
